import React, { createContext, useContext, useState } from 'react';

const CompanyContext = createContext();

export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }
  return context;
};

export const CompanyProvider = ({ children }) => {
  const [companies, setCompanies] = useState([]);
  const [searchCity, setSearchCity] = useState('');
  const [searchMetadata, setSearchMetadata] = useState(null);

  const updateCompanies = (companiesData, city, metadata = null) => {
    setCompanies(companiesData);
    setSearchCity(city);
    setSearchMetadata(metadata);
  };

  const clearCompanies = () => {
    setCompanies([]);
    setSearchCity('');
    setSearchMetadata(null);
  };

  const getCompanyByIndex = (index) => {
    const companyIndex = parseInt(index);
    return companies[companyIndex] || null;
  };

  const value = {
    companies,
    searchCity,
    searchMetadata,
    updateCompanies,
    clearCompanies,
    getCompanyByIndex
  };

  return (
    <CompanyContext.Provider value={value}>
      {children}
    </CompanyContext.Provider>
  );
};
